SponserRouting.$inject = ["$urlRouterProvider", "$stateProvider"];

function SponserRouting($urlRouterProvider, $stateProvider) {

    $urlRouterProvider.otherwise("/Sponser/NewRequest");

    $stateProvider

        .state('Sponser', {

            abstract: true,

            url: '/Sponser',

            template: '<ui-view id="Sponser"></ui-view>'

        })

        .state('Sponser.NewRequest', {

            url: '/NewRequest',

            controller: 'Sponser.NewRequestController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./NewRequest/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./NewRequest/NewRequest.module');

                        $ocLazyLoad.load({

                            name: 'NewRequestModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                title: "ثبتنام حامی",
                icon: "fas fa-plus"
            },

        })
        .state('Sponser.ApplicantList', {

            url: '/ApplicantList',

            controller: 'Sponser.ApplicantListController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./ApplicantList/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./ApplicantList/ApplicantList.module');

                        $ocLazyLoad.load({

                            name: 'ApplicantListModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                title: "درخواست های متقاضیان",
                icon: "fas fa-tasks"
            },

        })
        .state('Sponser.AvailableServicesList', {

            url: '/AvailableServicesList',

            controller: 'Sponser.AvailableServicesListController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./AvailableServicesList/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./AvailableServicesList/AvailableServicesList.module');

                        $ocLazyLoad.load({

                            name: 'AvailableServicesListModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                title: "درخواست های حامی",
                icon: "fas fa-tasks"
            },


        })
        .state('Sponser.ShowDetails', {

            url: '/ShowDetails/:requestId',

            controller: 'Sponser.ShowDetailsController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./ShowDetails/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./ShowDetails/ShowDetails.module');

                        $ocLazyLoad.load({

                            name: 'ShowDetailsModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "Sponser.AvailableServicesList",
                title: "جزئیات درخواست حامی شدن",
                icon: "fas fa-info-circle"
            },

        })
        .state('Sponser.DoingList', {

            url: '/DoingList',

            controller: 'Sponser.DoingListController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./DoingList/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./DoingList/DoingList.module');

                        $ocLazyLoad.load({

                            name: 'DoingListModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                title: "درخواست های در حال انجام",
                icon: "fas fa-tasks"
            },

        })
        .state('Sponser.ShowApplicantDetail', {

            url: '/ShowApplicantDetail/:requestId',

            controller: 'Sponser.ShowApplicantDetailController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./ShowApplicantDetail/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./ShowApplicantDetail/ShowApplicantDetail.module');

                        $ocLazyLoad.load({

                            name: 'ShowApplicantDetailModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "Sponser.ApplicantList",
                title: "جزئیات درخواست استفاده از خدمت",
                icon: "fas fa-info-circle"
            },

        })
        .state('Sponser.Profile', {

            url: '/Profile/:id/:type/:nationalId',

            controller: 'Sponser.ProfileController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./Profile/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./Profile/Profile.module');

                        $ocLazyLoad.load({

                            name: 'ProfileModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "Aplicant.BazarGetWay",
                title: "پروفایل",
                icon: "fas fa-info-circle"
            },

        }) /*endOfResolve*/ ;

}



export default SponserRouting;